import * as THREE from 'three';
import { Entity } from './Entity.js';
import { CONFIG, ASCII_CHARS } from '../core/config.js';

export class Powerup extends Entity {
    constructor(x, y, type, scene) {
        super(x, y, ASCII_CHARS.HEALTH_PACK, CONFIG.COLORS.POWERUP, scene);
        
        this.powerupType = type;
        this.lifetime = 20;
        this.collectRange = 1.2;
        
        // Add pulsing animation for powerups
        this.mesh.classList?.add('powerup-glow');
    }
    
    update(deltaTime, camera, gameState) {
        super.update(deltaTime, camera);
        
        this.lifetime -= deltaTime;
        if (this.lifetime < 3) {
            // Blink when about to expire
            this.opacity = Math.sin(this.lifetime * 10) * 0.5 + 0.5;
        }
        
        const player = gameState.player;
        if (!player) return this.lifetime <= 0;
        
        const distToPlayer = this.getDistanceTo(player);
        if (distToPlayer < this.collectRange) {
            this.applyEffect(player, gameState);
            this.destroy();
            return true; // Remove this powerup
        }
        
        return this.lifetime <= 0;
    }
    
    applyEffect(player, gameState) {
        switch(this.powerupType) {
            case 'health':
                gameState.stats.health = Math.min(
                    gameState.stats.maxHealth, 
                    gameState.stats.health + 30
                );
                break;
            case 'damage':
                // Temporary damage boost (could be made permanent for progression)
                player.damage *= 1.1;
                break;
            case 'speed':
                // Temporary speed boost
                player.speed *= 1.05;
                break;
        }
        
        // Show pickup effect
        this.showPickupEffect();
    }
    
    showPickupEffect() {
        const screenPos = this.getScreenPosition();
        if (!screenPos) return;
        
        const effectEl = document.createElement('div');
        effectEl.style.position = 'absolute';
        effectEl.style.left = screenPos.x + 'px';
        effectEl.style.top = screenPos.y + 'px';
        effectEl.style.color = '#ffff44';
        effectEl.style.fontSize = '14px';
        effectEl.style.fontWeight = 'bold';
        effectEl.style.pointerEvents = 'none';
        effectEl.style.zIndex = '150';
        effectEl.style.textShadow = '0 0 10px #ffff44';
        effectEl.textContent = this.getEffectText();
        
        document.getElementById('gameContainer').appendChild(effectEl);
        
        setTimeout(() => {
            if (effectEl.parentNode) effectEl.parentNode.removeChild(effectEl);
        }, 1000);
    }
    
    getEffectText() {
        switch(this.powerupType) {
            case 'health': return '+HEALTH';
            case 'damage': return '+DAMAGE';
            case 'speed': return '+SPEED';
            default: return '+POWERUP';
        }
    }
} 